module.exports = __webpack_public_path__ + "static/media/roi1.5f02a6ad.png";